import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes
})

const guestMiddleware = (next, token, isLoggedIn) => {
    if (token && isLoggedIn) {
        next({ name: 'account-request' })
    } else {
        next()
    }
}

const authMiddleware = (next, token, isLoggedIn, { meta: { permission } }) => {
    if (token && isLoggedIn) {
        const userRole = store.getters['auth/getField']('user').role

        if (!permission) {
            next()
            return
        }

        permission === userRole
            ? next()
            : next({ path: 'PageNotFound' })
    } else {
        next({ name: 'signin' })
    }
}

// middleware to check if user is authenticated
router.beforeEach(async (to, from, next) => {
    const token = store.getters['auth/getField']('token')
    let isLoggedIn = store.getters['auth/getField']('isLoggedIn')

    if (token && !isLoggedIn) {
        await store.dispatch('auth/fetchUser')
        isLoggedIn = store.getters['auth/getField']('isLoggedIn')
    }
    
    const routeMiddleware = to.meta.middleware

    // If middleware is *, just go to next route
    if (routeMiddleware === '*') {
        next()
    }

    //middleware for guest middleware type
    if (routeMiddleware === 'guest') {
        guestMiddleware(next, token, isLoggedIn)
    }

    //middleware for auth middleware type
    if (routeMiddleware === 'auth') {
        authMiddleware(next, token, isLoggedIn, to)
    }
})

export default router